export const SENSOR_DRIVER_MISSING_FROM_FIRMWARE = 'Sensor driver missing from firmware';

export function getWallDisplayTemperatureSensorError(status: {
	['temperature:0']?: { errors?: string[] };
	['thermostat:0']?: { current_C?: number };
} | null) {
	const errors = status?.['temperature:0']?.errors ?? [];
	const present = errors.length > 0 || (status?.['thermostat:0']?.current_C ?? 0) < -273;
	const driverMissing = errors.includes(SENSOR_DRIVER_MISSING_FROM_FIRMWARE);

	return { present, driverMissing };
}
